import { AnalyticsEventProperties, AnalyticsEventValue } from 'core/analytics/entities';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { AmplitudeService } from '../../interfaces';
import { AmplitudeServiceDecorator } from './AmplitudeServiceDecorator';

export class AmplitudeServiceWithFunnelContext extends AmplitudeServiceDecorator {
  constructor(
    amplitudeService: AmplitudeService,
    private readonly funnelSettingsService: FunnelSettingsServiceInterface,
  ) {
    super(amplitudeService);
  }

  trackEvent(event: AnalyticsEventValue, properties: AnalyticsEventProperties = {}) {
    return super.trackEvent(event, {
      ...properties,
      funnel_context: this.funnelSettingsService.getFunnelName(),
      funnel_platform: this.funnelSettingsService.getFunnelPlatform(),
      domain: this.funnelSettingsService.getDomainName(),
    });
  }
}
